import { render } from "./WhatsAppPromoCard.vue?vue&type=template&id=6791f9be&scoped=true"
import script from "./WhatsAppPromoCard.vue?vue&type=script&lang=js"
export * from "./WhatsAppPromoCard.vue?vue&type=script&lang=js"

import "./WhatsAppPromoCard.vue?vue&type=style&index=0&id=6791f9be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6791f9be"]])

export default __exports__